import React from 'react'
import Loader from 'react-loader-spinner'
import { checkPermission, translate } from '../utils/useful'
import store from '../stores/storeConfig'
import { initHeader } from '../stores/actionsList'

class DataGrid extends React.Component {
    state = {
        key: ''
    }
    handleHeaders = () => {
        let location = window.location.pathname.split('/')
        if (location[1] == 'en') {
            store.dispatch(initHeader(location[2]))
        } else {
            store.dispatch(initHeader(location[1]))
        }
    }

    render() {
        return (
            <div className="row m-0">
                {this.props.data?.map((prop, index) => {
                    let Component = this.props.component
                    let permission = checkPermission(`${this.props.permissionBaseKey}.${prop.key}`, null, this.props.applet)
                    // console.log("permissionaaa", permission, `${this.props.permissionBaseKey}.${prop.key}`)
                    // if in admin pages Section have a (showInDashboard: true) , show in dashboard
                    if (Component && permission) {
                        // console.log('propsssllllll',prop)
                        return (
                            <div key={index} className={(this.props.marginBottom ?? ' mb-1 mb-md-4') + ' ' + this.props.col} onClick={() => this.handleHeaders()}>
                                <Component data={prop} schema={this.props.schema} dontShowPrice={this.props.dontShowPrice} background={this.props.background} settings={this.props.settings} permissions={this.props.permissions} applet={this.props.applet} />
                            </div>
                        )
                    }
                })}
                <div className="col-12 text-center ">

                    {this.props.data?.length === 0 && !this.props.isLoading && (
                        <p style={{ fontSize: 16, color: '#789', marginTop: 20 }}>{translate('found-nothing')}</p>
                    )}

                    {this.props.isLoading && !this.props.hideLoader && (
                        <div className="mt-2">
                            <Loader
                                type={this.props.type ?? "Oval"}
                                color={this.props.color ?? "#202020"}
                                height={this.props.width ?? 50}
                                width={this.props.height ?? 50}
                            />
                        </div>
                    )}
                </div>

            </div>
        )
    }
}

export default (DataGrid);